import React, { Component } from 'react';
import './App.css';

import {BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import MainPage from "./Pages/index";
import NotFoundPage from "./Pages/404";
import SignIn from "./Pages/SignIn";
import SignUp from "./Pages/SignUp";
import Upload from "./Pages/Upload";
import Display from "./Pages/Display";
import EngDisplay from "./Pages/EngDisplay";
import ScDsiplay from "./Pages/ScDisplay";
import BADisplay from "./Pages/BADisplay";
import ArtsDisplay from "./Pages/ArtsDisplay";
import ITDisplay from "./Pages/ITDisplay";
import HScDisplay from "./Pages/HScDisplay";
import LAWDisplay from "./Pages/LAWDisplay";
import BTCDisplay from "./Pages/BTCDisplay";
import { app } from './Pages/firebaseconfig';
import ForgetPassword from './Pages/ForgetPassword';
import TOS from './Pages/TOS';
import privacypolicy from './Pages/PrivacyPolicy';
import ContactForm from './Pages/ContactForm'
import Report from './Pages/Report'
import AppliedStudies from './Pages/ASDisplay';

class App extends Component{
        logout = () => {
          app.auth().signOut();
      }


  render(){
   return (
     <Router>
       <Switch>
       <Route exact path="/" component={MainPage} />
       <Route exact path="/Engineering" component={EngDisplay} />
       <Route exact path="/Science" component={ScDsiplay} />
       <Route exact path="/Business" component={BADisplay} />
       <Route exact path="/Arts" component={ArtsDisplay} />
       <Route exact path="/IT" component={ITDisplay} />
       <Route exact path="/HealthSportSciences" component={HScDisplay} />
       <Route exact path="/Law" component={LAWDisplay} />
       <Route exact path="/BTC" component={BTCDisplay} />
       <Route exact path="/Login" component={SignIn} />
       <Route exact path="/Upload_Your_Documents" component={Upload}/>
       <Route exact path="/Documents" component={Display}/>
       <Route exact path="/ForgotPassword" component={ForgetPassword}/>
       <Route exact path="/Signup" component={SignUp}/>
       <Route exact path="/Termsofservice" component={TOS}/>
       <Route exact path="/Privacypolicy" component={privacypolicy}/>
       <Route exact path="/Contactus" component={ContactForm}/>
       <Route exact path="/Report" component={Report}/>
       <Route exact path="/Appliedstudies" component={AppliedStudies}/>
       </Switch>
      </Router> 
   );
   }
}

export default App;
